export const UNKNOWN = 'unknown';
export const SUCCESS = 'success';
export const PENDING = 'pending';
export const FAILED = 'failed';
export const ERROR = 'error';
